import { useState, useEffect, useCallback, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import {
  GoogleReCaptchaProvider,
  useGoogleReCaptcha,
} from "react-google-recaptcha-v3";
import { RECAPTCHA_SITEKEY } from "../../../utils/recaptchaKeys";
import allActions from "../../../state/actions";
import InfoTooltipElement from "../../shared/infoTooltipElement/InfoTooltipElement";
import CampiRichiediInfo from "../campiRichiediInfo/CampiRichiediInfo";

const ProductRichiediInformazioni = () => {
  const currentPage = useSelector((state) => state.currentPage);
  // lingua corrente
  const suffissoLang = currentPage.currentLang.replace("_", "");
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={RECAPTCHA_SITEKEY}
      language={suffissoLang}
      useRecaptchaNet={false}
      useEnterprise={false}
      scriptProps={{
        async: true, // optional, default to false,
        defer: false, // optional, default to false
        appendTo: "head", // optional, default to "head", can be "head" or "body",
        nonce: undefined, // optional, default undefined
      }}
    >
      <SignupForm />
    </GoogleReCaptchaProvider>
  );
};

const SignupForm = () => {
  const dispatch = useDispatch();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const history = useHistory();
  // store data
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm({
    mode: "onChange",
  });
  const pageContent = useSelector((state) => state.currentPage.pageContent);
  const currentPage = useSelector((state) => state.currentPage);
  const genericheTranslation = useSelector(
    (state) => state.translations.generiche
  );
  const paginestaticheTranslation = useSelector(
    (state) => state.translations.paginestatiche
  );

  // local state
  const [isFormSending, setIsFormSending] = useState(false);
  const [reCaptcha, setReCaptcha] = useState("");

  // Create an event handler so you can call the verification on button click event or form submit
  const handleReCaptchaVerify = useCallback(
    async (event) => {
      if (!executeRecaptcha) {
        console.log("Execute recaptcha not yet available");
        return;
      }
      console.log("Execute recaptcha now");
      const token = await executeRecaptcha("productForm");
      setReCaptcha(token);
    },
    [executeRecaptcha]
  );

  useEffect(() => {
    handleReCaptchaVerify();
    // mando pagina contatti-ok solo dopo la risposta di sendRichiediInfoProdotto()
    if (
      isFormSending === true &&
      currentPage?.status === "OK" &&
      currentPage?.message === "Messaggio inviato"
    ) {
      setIsFormSending(false);

      // mando alla pagina contatti-ok che ho già recuperato da sendRichiediInfoProdotto()
      // mostro spinner
      dispatch(allActions.isFetchingAction.loadSpinner());

      // vado alla pagina contatti-ok
      dispatch(
        allActions.changePageActions.changePage(
          "",
          paginestaticheTranslation.contattiok.itemName,
          paginestaticheTranslation.contattiok.itemLink,
          history
        )
      );
    } else if (
      isFormSending === true &&
      currentPage?.status === "KO" &&
      currentPage?.message === "Messaggio non inviato"
    ) {
      setIsFormSending(false);

      // mando alla pagina contatti-ko che ho già recuperato da sendContatti()
      // mostro spinner
      dispatch(allActions.isFetchingAction.loadSpinner());

      // vado alla pagina contatti-ko
      dispatch(
        allActions.changePageActions.changePage(
          "",
          paginestaticheTranslation.contattiko.itemName,
          paginestaticheTranslation.contattiko.itemLink,
          history
        )
      );
    }

    return () => {
      //console.log('cleaned up');
    };
  }, [isFormSending, currentPage, handleReCaptchaVerify]);

  // controllo che esista la proprietà detail (altrimenti vuol dire che sto ancora recuperando i dati)
  if (!pageContent.detail) {
    return <div></div>;
  }

  const onSubmitFormRichiediInfo = (data) => {
    console.log(data);

    // CONTROLLO DI AVERE IL TOKEN DI RECAPTCHA V4
    if (!reCaptcha) return;

    // chiamo action creator
    if (
      data.nome !== "" &&
      data.email !== "" &&
      data.messaggio !== "" &&
      reCaptcha !== ""
    ) {
      // mostro preloader
      setIsFormSending(true);

      const dataForm = {
        nome: data.nome,
        email: data.email,
        messaggio: data.messaggio,
        opzionivarianti: data?.opzionivarianti,
        titoloProdotto: pageContent.detail.titolo,
        codiceProdotto: pageContent.detail.codice,
        recaptcha: reCaptcha,
      };

      dispatch(
        allActions.staticDetailActions.sendRichiediInfoProdotto(
          currentPage.currentLang,
          dataForm
        )
      );
    }
  };

  const isDisabledClick = isFormSending ? "pointer-events-none" : "";
  const isButtonSending = isFormSending ? true : false;
  // lingua corrente
  const suffissoLang = currentPage.currentLang.replace("_", "");
  return (
    <Fragment>
      <span className="text-xl font-opensanssemibold flex items-center justify-between">
        {genericheTranslation.compilaformpermaggiorinfo.itemName.toUpperCase()}
        <InfoTooltipElement
          iconColor="ribola-astral"
          fontSize="text-3xl"
          tooltipColor="ribola-astral"
          tooltipText={
            genericheTranslation.questoprodottonondisponibile.itemName
          }
        />
      </span>
      <form onSubmit={handleSubmit(onSubmitFormRichiediInfo)} noValidate>
        <CampiRichiediInfo
          key="campiRichiediInfo"
          errors={errors}
          register={register}
          isDisabledClick={isDisabledClick}
          isButtonSending={isButtonSending}
          onClickHandler={handleReCaptchaVerify}
        />
      </form>
      <div className="grid grid-cols-60 mt-8"></div>

      <div className="w-full flex justify-center"></div>
    </Fragment>
  );
};

export default ProductRichiediInformazioni;
